const store = {
    // clean all the saved data
    clear: function() {
        // window.sessionStorage.clear();
        localStorage.clear();
    },
    /**
     * Set an item to the store
     * @param {string} key   the key
     * @param {Object} value the object
     */
    setItem: function(key, value) {
        let s;
        if (value == null || typeof value === 'undefined') {
            s = '';
        } else {
            if (typeof value === 'string') {
                s = value;
            } else {
                s = JSON.stringify(value);
            }
        }
        window.localStorage.setItem(key, s);
    },

    /**
     * Get an item from the store
     * @param  {string} key the key
     * @return {Object}     the value. maybe null
     */
    getItem: function(key) {
        const stringVal = window.localStorage.getItem(key);
        if (stringVal == null || stringVal.length === 0 ) return null;
        if (stringVal.startsWith('{') || stringVal.startsWith('}')) {
            return JSON.parse(stringVal);
        }

        return stringVal;
    },

    /**
     * Delete an item from the storage
     * @param {string} key
     */
    deleteItem: function(key) {
        window.localStorage.removeItem(key);
    },

    /**
     * Returns the value of the item and then remove it
     * @param {string} key the item key
     * @returns {Object} the value
     */
    getTransientItem: function(key) {
        const ret = this.getItem(key);
        this.deleteItem(key);
        return ret;
    },

    saveToken: function(token) {
        this.setItem('_cip_token', token);
    },

    getToken: function() {
        return this.getItem('_cip_token');
    },

    removeToken: function() {
        window.localStorage.removeItem('_cip_token');
    },

    saveUser: function(user) {
        this.setItem('_cip_user', user);
    },

    removeUser: function() {
        this.deleteItem('_cip_user');
    },

    /**
     * Return the user object with methods from prototype defined in components/User.js
     * @return {Object}
     */
    getUser: function() {
        const u = this.getItem('_cip_user');
        return u;
    },

    saveBlueBeanAccount: function(blueAccount) {
        this.setItem('_cip_blueAccount', blueAccount);
    },

    getBlueBeanAccount: function(blueAccount) {
        const a = this.getItem('_cip_blueAccount', blueAccount);
        return a;
    },
};

export default store;